import { render, staticRenderFns } from "./wmcxyl.vue?vue&type=template&id=213dc57b&scoped=true"
import script from "./wmcxyl.vue?vue&type=script&lang=js"
export * from "./wmcxyl.vue?vue&type=script&lang=js"
import style0 from "./wmcxyl.vue?vue&type=style&index=0&id=213dc57b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213dc57b",
  null
  
)

export default component.exports